//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import storage from 'storejs'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  props: {
    title: {
      type: String
    },
    isCollect: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      showPopover: true,
      urlName: this.$route.name,
      timer: null,
      visible2: false,
      showGuid: false
    }
  },
  created() {
    let count = Number(localStorage.getItem('count'))
    if (!count || count == 0) {
      this.showGuid = true
    }
    count += 1
    localStorage.setItem('count', count)
  },
  components: {
  },
  computed: {
    ...mapGetters(['currentPageInfoComponent', 'formulaNotInfoPageList']),
    showInfo() {
      // debugger
      console.log('currentPageInfoComponent',this.currentPageInfoComponent);
      let self = this
      let currentPath = this.$route.name
      if (self.formulaNotInfoPageList[currentPath]) {
        return false
      } else {
        this.checkInfo()
        console.log();
        return true
      }
    }
  },
  methods: {
    ...mapMutations(["setCurrentPageInfoComponent"]),
    checkInfo() {
      let componentsListStr = localStorage.getItem('componentsList')
      const componentsList = componentsListStr ? JSON.parse(componentsListStr) : []
      console.log('componentsList',componentsList)
      const index = componentsList.findIndex(ele => {
          let name=ele.name.replace('_info', '')
          return  name===this.$route.name
      })
      index==-1&&this.setCurrentPageInfoComponent('commonInfo')
    },
    closePop(event) {
      this.showGuid = false
      // 防止穿透
      event.stopPropagation()
    },
    // 跳转
    showFormulaInfo(event) {
      this.showGuid = false
      event.stopPropagation()
      event.preventDefault()
      console.log(this.$refs.medicalEditor_info.classList, '气泡初始带的类')
      let myPopoverArr = document.getElementsByClassName('medicalEditor_my-popover') || []
      console.log(myPopoverArr, '气泡伪数组')
      if (this.$refs.medicalEditor_info.classList.contains('divBlock')) {
        // 如果已经有一个气泡显示，再次点击所有的都隐藏
        for (let popIndex = 0; popIndex < myPopoverArr.length; popIndex++) {
          myPopoverArr[popIndex].classList.remove('divBlock')
        }
      } else {
        // 没有气泡展示，展示当前
        for (let popIndex = 0; popIndex < myPopoverArr.length; popIndex++) {
          myPopoverArr[popIndex].classList.remove('divBlock')
        }
        this.$refs.medicalEditor_info.classList.add('divBlock')
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/layout/components/topDesc.vue